module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"language-prompt":"Langue du questionnaire","language-fr":"Français","language-en":"Anglais"},"en":{"language-prompt":"Show questionnaire in","language-fr":"French","language-en":"English"}}')
  delete Component.options._Ctor
}
